import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { shopifyClient } from './lib/shopify-client';
import { AnalyticsProvider } from './contexts/AnalyticsContext';
import { AnalyticsErrorBoundary } from './components/AnalyticsErrorBoundary';
import App from './App.tsx';
import './index.css';
import './i18n'; // Initialize i18n

const GA4_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID || '';
const IS_DEVELOPMENT = import.meta.env.DEV;

createRoot(document.getElementById('root')!).render(
  <AnalyticsErrorBoundary>
    <BrowserRouter>
      <ApolloProvider client={shopifyClient}>
        <AnalyticsProvider
          measurementId={GA4_MEASUREMENT_ID}
          debug={IS_DEVELOPMENT}
        >
          <App />
        </AnalyticsProvider>
      </ApolloProvider>
    </BrowserRouter>
  </AnalyticsErrorBoundary>
);
